import React, { useEffect } from 'react'
import './disconnected.scss'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import api from '../../api';


function Disconnected() {

    useEffect(() => {
        document.title = 'Disconnected'
    }, [])

    const API = process.env.REACT_APP_API_URL;
    const navigate = useNavigate()


    const rejoin = async () => {
        try {
            const prevRoomId = localStorage.getItem("flashroom_most_recent");
            const name = localStorage.getItem("flashroom-accountName");
            const clientId = localStorage.getItem("flashroom_id");

            if (!name || !prevRoomId || !clientId) return;

            const { data } = await axios.patch(`${API}/api/rooms/${prevRoomId}/members/${clientId}/rejoin`);

            localStorage.setItem("flashroom_roomToken", data.token);


            navigate(`/room/${prevRoomId}`);
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                const status = error.response?.status;
                const code = error.response?.data?.code;

                if (
                    status === 401 &&
                    (code === "ROOM_TOKEN_EXPIRED" || code === "ROOM_TOKEN_MISSING")
                ) {
                    navigate("/join");
                    return;
                }
            }

        }
    }


    return (
        <div id='disconnected' style={{ backgroundImage: `url('images/cbb2.png')` }}>
            <section
                style={{
                    minHeight: "100vh",
                    display: "grid",
                    placeItems: "center",
                    padding: "24px",
                }}
            >
                <div
                    style={{
                        width: "min(560px, 100%)",
                        padding: "22px",
                        borderRadius: "16px",
                        background: "rgba(255,255,255,0.08)",
                        border: "1px solid rgba(255,255,255,0.16)",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <h1 style={{ margin: 0, fontSize: "1.6rem" }}>You’ve been disconnected</h1>

                    <p style={{ marginTop: 10, marginBottom: 18, opacity: 0.9, lineHeight: 1.5 }}>
                        Looks like you were inactive for a bit, so we closed the connection to keep things tidy.
                        Want to jump back in?
                    </p>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                        <Link
                            to="/"
                            style={{
                                padding: "10px 14px",
                                borderRadius: "12px",
                                textDecoration: "none",
                                background: "rgba(255,255,255,0.16)",
                                border: "1px solid rgba(255,255,255,0.22)",
                                color: "inherit",
                                fontWeight: 600,
                            }}
                        >
                            Go to FlashRoom Home
                        </Link>

                        <div
                            onClick={rejoin}
                            style={{
                                cursor: 'pointer',
                                padding: "10px 14px",
                                borderRadius: "12px",
                                textDecoration: "none",
                                background: "rgba(0,0,0,0.22)",
                                border: "1px solid rgba(255,255,255,0.18)",
                                color: "inherit",
                                fontWeight: 600,
                            }}
                        >
                            Rejoin last room
                        </div>
                    </div>

                    <p style={{ marginTop: 14, opacity: 0.75, fontSize: ".95rem" }}>
                        Tip: If you were in the middle of editing, don’t worry—your changes should still be there.
                    </p>
                </div>
            </section>
        </div>
    )
}

export default Disconnected
